import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { Icon } from '@/components/atoms/Icon/Icon';

export const TextIcon = ({ text, centerText, showIcon }: TextIconProps) => {
  return (
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: sp[12],
        justifyContent: centerText ? 'center' : 'left',
      }}
    >
      {showIcon && (
        <Box
          sx={{
            background: '#cfe09b',
            color: '#003413',
            width: '20px',
            minWidth: '20px',
            maxWidth: '20px',
            height: '20px',
            minHeight: '20px',
            maxHeight: '20px',
            borderRadius: '9999px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon icon='check' type='fas' fontSize={12} />
        </Box>
      )}
      <Box
        sx={{
          typography: 'bodyLg',
          textAlign: centerText ? 'center' : 'left',
          color: '#404042',
        }}
      >
        {text}
      </Box>
    </Stack>
  );
};

interface TextIconProps {
  text: string;
  centerText: boolean;
  showIcon: boolean;
}

TextIcon.displayName = 'TextIcon';

export default TextIcon;
